// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3zGoo","inputDescription":"styles_inputDescription__vETwW"};